/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Body schema for POST /generate_product_qr/bulk_grid. Internal to SdsWebSwift —
 * not promoted to `SdsWebApiProtocol` until a stable consumer needs the contract.
 * @export
 * @interface BulkProductQrRequest
 */
export interface BulkProductQrRequest {
    /**
     * Retailer IDs (article numbers) to encode + label. One QR per ID. Order is preserved
     * in the resulting grid (left-to-right, top-to-bottom).
     * @type {Array<string>}
     * @memberof BulkProductQrRequest
     */
    retailerIds: Array<string>;
    /**
     * Number of columns in the grid. Rows derived as ceil(count / cols). Default 4 if omitted.
     * @type {number}
     * @memberof BulkProductQrRequest
     */
    cols?: number | null;
    /**
     * QR pixels-per-module (5–50). Same semantics as the single-QR `size` query param. Default 20.
     * @type {number}
     * @memberof BulkProductQrRequest
     */
    qrSize?: number | null;
}

export function BulkProductQrRequestFromJSON(json: any): BulkProductQrRequest {
    return BulkProductQrRequestFromJSONTyped(json, false);
}

export function BulkProductQrRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkProductQrRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retailerIds': json['retailerIds'],
        'cols': !exists(json, 'cols') ? undefined : json['cols'],
        'qrSize': !exists(json, 'qrSize') ? undefined : json['qrSize'],
    };
}

export function BulkProductQrRequestToJSON(value?: BulkProductQrRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retailerIds': value.retailerIds,
        'cols': value.cols,
        'qrSize': value.qrSize,
    };
}


